<template>
  <div class="auto-complete" v-outside="outside" :class="{ focused: showList }">
    <div class="d-flex flex-wrap">
      <input
        v-model="searchValue"
        ref="input"
        :disabled="disabled"
        @keyup="onChange"
        @click="onFocus()"
        class="form-control w-100"
        :class="{
          'form-control-sm': small,
          error: required && !value,
        }"
        style="min-width: 100%"
        :placeholder="placeholder || 'Chọn '"
        :required="required"
      />
      <div class="tags" v-if="multi && tag">
        <div
          class="tag tag-primary tag-sm"
          v-for="item in value || []"
          :key="item.id || item"
        >
          {{ item.label || item.name || item }}
          <i class="fa fa-times pointer" @click="removeItem(item)" />
        </div>
      </div>
    </div>
    <div
      v-if="showList"
      class="search-list"
      :class="{ 'search-list-top': position == 'top' || isTop }"
    >
      <div
        v-for="(item, idx) in showedList"
        :tabindex="idx"
        :key="item.id || item.key"
        class="search-item"
        :class="{ active: !multi && item.id == value }"
        @click="onSelect(item)"
      >
        <check-box
          v-if="multi"
          :value="(value || []).find((i) => i.id == item.id || i == item.id)"
          :title="item.label || item.name || item"
        />
        <template v-else>
          <slot name="item" :item="item">
            <span>{{ item.label || item.name || item }}</span>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "list",
    "multi",
    "value",
    "placeholder",
    "disabled",
    "isDynamic",
    "small",
    "required",
    "position",
    "valueShow",
    "searchFunction",
    "tag",
  ],
  data: function () {
    return {
      searchValue: "",
      originalList: [],
      showedList: [],
      showList: false,
      isTop: false,
      searchRef: null,
    }
  },
  created() {
    this.originalList = JSON.parse(JSON.stringify(this.$props.list || []))
    this.showedList = this.originalList
    this.getName()
  },
  mounted() {
    if (!this.value) {
      // this.fetchOptions()
    }
  },
  beforeDestroy() {
    if (this.searchRef) {
      clearTimeout(this.searchRef)
    }
  },
  watch: {
    list: function () {
      this.originalList = JSON.parse(JSON.stringify(this.$props.list || []))
      this.showedList = this.originalList
      if (!this.isDynamic) {
        this.getName()
      }
    },
    value: function () {
      this.getName()
    },
  },
  methods: {
    async fetchOptions(keyword = "") {
      if (!this.searchFunction) return

      const res = await this.searchFunction(keyword)
      this.originalList = res || []
      this.showedList = this.originalList
      this.getName()
    },
    removeItem(item) {
      const temp = [...this.value.filter((i) => i != item)]
      this.$emit("input", temp)
      this.$emit("change", temp)
      this.$emit("changeOption", temp)
    },
    onBlur() {
      this.showList = false
    },
    getName() {
      if (this.multi) {
        if (this.tag) {
          this.searchValue = ""
        } else {
          this.searchValue = this.originalList
            .filter((a) => (this.value || []).indexOf(a?.id) > -1)
            .map((a) => a.name)
            .join(", ")
        }
      } else {
        var item = this.originalList.find((i) => i?.id == this.value)
        if (!item) {
          item = this.showedList.find((i) => i?.id == this.value)
        }
        if (item) {
          this.searchValue = item.name
        } else {
          this.searchValue = this.valueShow || ""
        }
      }
    },
    onChange(e) {
      let key = e.target.value

      // if enter
      if (e.keyCode === 13) {
        // run search immediately
        if (this.searchFunction) {
          this.fetchOptions(key)
        }
        return
      }
      // console.log("searching", key, this.searchFunction)
      if (this.searchFunction) {
        const findFn = async () => {
          const res = await this.searchFunction(key)
          this.showedList = res || []
        }
        if (this.searchRef) {
          clearTimeout(this.searchRef)
        }
        this.searchRef = setTimeout(findFn, 1000)
      } else {
        this.showedList = this.originalList.filter((p) => {
          return this.$changeAlias(p.name + (p.search || "")).includes(
            this.$changeAlias(key),
          )
        })
      }
      if (this.multi) {
        return
      }
      this.$emit("change", key)
    },
    onSelect(item) {
      console.log("selected", item)
      if (this.multi) {
        var temp = [...(this.value || [])]
        if (temp.find((i) => i.id == item.id || i == item.id)) {
          temp = temp.filter((i) => i.id != item.id && i != item.id)
        } else {
          temp.push(item)
        }
        // temp = temp.filter((a) => this.originalList.find((b) => b.id == a.id))
        this.$emit("input", temp)
        this.$emit("change", temp)
        this.$emit("changeOption", temp)
        if (this.tag) {
          this.searchValue = ""
        } else {
          this.searchValue = this.originalList
            .filter((a) => (this.value || []).find((i) => i.id == a.id || i == a.id))
            .map((a) => a.name)
            .join(", ")
        }
      } else {
        this.$emit("input", item.id)
        this.$emit("change", item.id)
        this.$emit("changeOption", item.id)
        this.searchValue = item.name
        this.showList = false
      }
    },
    onFocus() {
      this.showList = true
      this.$refs.input.select()
      this.showedList = this.originalList
      this.isTop =
        window.innerHeight -
          this.$refs.input.getBoundingClientRect().top +
          window.scrollY <
        200
      if (this.searchFunction && this.showedList.length == 0) {
        this.onChange({ target: { value: this.searchValue } })
      }
    },
    outside() {
      if (this.showList === true) {
        this.showList = false
      }
      if (this.multi) {
        if (this.tag) {
          this.searchValue = ""
        } else {
          this.searchValue = this.originalList
            .filter((a) => (this.value || []).indexOf(a.id) > -1)
            .map((a) => a.name)
            .join(", ")
        }
      }
      if (!this.value) {
        this.searchValue = ""
      }
    },
  },
}
</script>
